<template>
    <modal ref="modal">
        <div class="d-flex flex-column gap-6 mt-6">
            <p class="fs-4 fw-600 text-center">{{$trans('storefront::image_editor.add_instructions_for_sticker')}}</p>

            <div class="d-flex flex-column gap-3">
                    <textarea cols="30" rows="6" class="no-resize form-control" v-model="store.instruction"
                              :placeholder="$trans('storefront::image_editor.add_instructions_for_sticker_description')"
                    ></textarea>

                <scroll-box style="max-height: 140px">
                    <file-upload id="file-upload" :files="store.instruction_files" :accept="store.mediaOptions.mimes"></file-upload>
                </scroll-box>
            </div>

            <div class="d-flex flex-column flex-sm-row gap-2 gap-sm-4 justify-content-end">
                <label for="file-upload" class="btn btn-secondary btn-medium px-5">
                    <template v-if="store.instruction_files.length > 0">
                        {{$trans('storefront::image_editor.add_more_files')}}
                    </template>
                    <template v-else>
                        {{$trans('storefront::image_editor.browse_file')}}
                    </template>
                </label>
                <button type="button" class="btn btn-primary btn-medium" data-dismiss="modal">{{$trans('storefront::image_editor.done')}}</button>
            </div>
        </div>
    </modal>
</template>

<script>
import {useImageEditorStore} from "../store";

export default {
    setup() {
        const store = useImageEditorStore();
        return {store};
    },
    methods: {
        open() {
            this.$refs['modal'].openModal();

            this.loadDrafts();
        },
    }
}
</script>
